type Props = {
  label?: string;
  value: number;
  setValue?: any;
  printValue?: boolean;
  disabled?: boolean;
  min?: number;
  max?: number;
  step?: number;
  valueMultiplier?: number;
  valueSuffix?: string;
  className?: string;
  decimalPlaces?: number;
};

export default function RangeSelector({
  label,
  value,
  setValue,
  printValue = true,
  disabled = false,
  min = 0.01,
  max = 1,
  step = 0.01,
  valueMultiplier = 100,
  valueSuffix = "%",
  className,
  decimalPlaces = 0,
}: Props) {
  const prettyValue =
    decimalPlaces > 0
      ? (value * valueMultiplier).toFixed(decimalPlaces)
      : Math.round(value * valueMultiplier);

  const percent = ((value - min) / (max - min)) * 100;

  return (
    <div>
      {label && (
        <label
          htmlFor="steps-range"
          className="text-center block mb-2 text-sm font-medium text-black dark:text-black"
        >
          {label} {printValue && `: ${prettyValue}${valueSuffix}`}
        </label>
      )}
      <input
        id="rangeSelector"
        type="range"
        min={min}
        max={max}
        value={value}
        onChange={(event) => {
          setValue(Number(event.target.value));
        }}
        step={step}
        className={
          className ||
          "w-96 h-2 rounded-lg appearance-none cursor-pointer"
        }
        style={{
          accentColor: "rgb(0 180 123)",
          background: `linear-gradient(to right, rgb(0 180 123) 0%, rgb(0 180 123) ${percent}%, rgb(229 231 235) ${percent}%, rgb(229 231 235) 100%)`,
          borderRadius: "9999px",
        }}
        disabled={disabled}
      ></input>
    </div>
  );
}
